<div class="new-user-shelf__container"
     [ngClass]="{'ms-bgc-nla': !isVisualRefresh,
                 'width-restrictor--no-gutter': !isConsumer,
                 'new-user__container--collapsed': collapsed,
                 'new-user__container--collapsed--consumer': isConsumer && collapsed}"
     role="banner">
    <div class="new-user-shelf__inner ms-bgc-nl">
        <img [src]="collapsed ? shelfImage1Small : shelfImage1"
             class="new-user-shelf__image1"
             role="presentation"
             [ngClass]="{'new-user-shelf__image1--consumer': isConsumer}">
        <div class="new-user-shelf__inner-content ms-fcl-np"
             [ngClass]="{'new-user-shelf__inner-content--collapsed': collapsed}">
            <div class="new-user-shelf__title"
                 [ngClass]="{'new-user-shelf__title--collapsed': collapsed}">{{ isConsumer ? shelfTitleConsumer :
                shelfTitle }}</div>
            <div *ngIf="!collapsed"
                 class="new-user-shelf__subtitle">{{ shelfContentSubtitle }}</div>
            <div class="new-user-shelf__buttons-container">
                <button [ngClass]="{
                            'generic-button generic-button--fluent generic-button--fluent--primary ms-bgc-tda ms-bgc-w-h ms-bgc-w-a ms-fcl-tda-h ms-fcl-tda-a': !fluentRefresh,
                            'generic-button--fluentvnext generic-button--fluentvnext--primary': fluentRefresh}"
                        [attr.aria-label]="createNew"
                        (click)="onClickCreateNew()">
                    <span [ngClass]="{'generic-button__text': !fluentRefresh}">{{ createNew }}</span>
                </button>
                <button [ngClass]="{
                            'generic-button generic-button--fluent generic-button--fluent--secondary ms-bgc-w ms-bgc-tda-h ms-bgc-tda-a ms-fcl-tda ms-fcl-w-h ms-fcl-w-a': !fluentRefresh,
                            'generic-button--fluentvnext generic-button--fluentvnext--default': fluentRefresh}"
                        [attr.aria-label]="exploreApps"
                        (click)="onClickExploreApps()">
                    <span [ngClass]="{'generic-button__text': !fluentRefresh}">{{ exploreApps }}</span>
                </button>
            </div>
        </div>
        <img [src]="collapsed ? shelfImage2Small : shelfImage2"
             class="new-user-shelf__image2"
             role="presentation"
             [ngClass]="{'new-user-shelf__image2--consumer': isConsumer}">
    </div>
</div>
